import FaqSection from "../components/FaqSection";

export default function FaqPage({ data }) {
  return (
    <div style={{ paddingTop: "1rem" }}>
      <FaqSection data={data} />
    </div>
  );
}
